/**
 * @generated SignedSource<<4ab3c425b9b8ca16040953f3b399f51a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NativeIssueTableWithSelectedIssuesProvider_project$data = {
  readonly createIssues: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly editIssues?: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"IssueRealtimeUpdater_project" | "IssueTable_project">;
  readonly " $fragmentType": "NativeIssueTableWithSelectedIssuesProvider_project";
};
export type NativeIssueTableWithSelectedIssuesProvider_project$key = {
  readonly " $data"?: NativeIssueTableWithSelectedIssuesProvider_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider_project">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "NativeIssueTableWithSelectedIssuesProvider_project",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "editIssues",
          "args": [
            {
              "kind": "Literal",
              "name": "type",
              "value": "EDIT_ISSUES"
            }
          ],
          "concreteType": "JiraProjectAction",
          "kind": "LinkedField",
          "name": "action",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": "action(type:\"EDIT_ISSUES\")"
        }
      ]
    },
    {
      "alias": "createIssues",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "CREATE_ISSUES"
        }
      ],
      "concreteType": "JiraProjectAction",
      "kind": "LinkedField",
      "name": "action",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": "action(type:\"CREATE_ISSUES\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "IssueRealtimeUpdater_project"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueTable_project"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "4533ca80ef71718ba0712a1b7d6bfd66";

export default node;
